<template>
    <div>
        <div class="container container-small py-5">
            <template v-if="tokens != null && tokens.length > 0">
                <div class="row align-items-center" v-for="t in tokens">
                    <div class="col-auto">
                        <div class="form-group mb-0">
                            <span class="ml-2 mr-2">
                                <img src="/media/mastercard.svg" v-if="t.cardType == 'Mastercard'">
                                <img src="/media/visa.png" v-if="t.cardType == 'Visa'">
                            </span>
                            {{t.cardNumberMask}}
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="link d-block" @click="remove(t.id)">Sterge cardul</div>
                    </div>
                </div>
            </template>
            <div class="text-center" v-else-if="tokens == null || !tokens.length">
                {{ $t('no_saved_credit_card') }}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'Cards',
        data() {
            return {
                tokenId: null
            }
        },
        computed: {
            ...mapGetters({
                'tokens': 'payuTokens/getTokens'
            })
        },
        mounted() {
            this.getTokens();
        },
        methods: {
            ...mapActions({
                'getTokens': 'payuTokens/getPayuTokens',
                'deleteToken': 'payuTokens/deleteToken'
            }),

            remove(id) {
                this.tokenId = id;

                this.$dialog.confirm({
                    title: this.$t('card_delete_title'),
                    message: this.$t('card_delete_body'),
                    cancelButtonText: this.$t('no'),
                    confirmButtonText: this.$t('yes'),
                    beforeClose: this.deleteTokenDo
                })
                .then(() => {
                    //on accept
                })
                .catch(() => {
                    // on cancel
                });
            },

            deleteTokenDo(action, done) {
                if(action == 'confirm') {
                    this.deleteToken(this.tokenId).then(async response => {
                        done();
                    }).catch(err => {
                        if(err.response) {
                            this.$dialog.alert({
                                'message': err.response.data.error.error_msg,
                                'confirmButtonText': this.$t('btn_i_understand')
                            });
                        }
                        done();
                    });
                }
                else {
                    done();
                }
            }
        }
    }
</script>
